var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveRolesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_1_form"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3333 22.6666C17.8514 23.8592 16.8125 24.92 15.3655 25.697C13.9185 26.4741 12.1377 26.9273 10.2783 26.992C8.41882 27.0566 6.57647 26.7292 5.01484 26.0567C3.4533 25.3843 1.66726 23.8193 1 22.6666M1 22.6666V25.5556M1 22.6666H3.88889M1 5.33333C1.4819 4.14073 2.52081 3.07993 3.96781 2.30293C5.41481 1.52593 7.19561 1.07263 9.05496 1.00801C10.9145 0.94341 12.7568 1.27078 14.3184 1.94323C15.8799 2.61567 17.666 4.18066 18.3333 5.33333M18.3333 5.33333V2.44444M18.3333 5.33333H15.4444M7.08364 15.4444H12.2497C12.7144 15.4444 12.9466 15.4444 13.1545 15.4776C13.8736 15.5929 14.4955 15.9978 14.8441 16.5776C14.9446 16.7451 15.0181 16.9442 15.1651 17.3422C15.3417 17.8206 15.43 18.0598 15.4419 18.2527C15.484 18.9332 14.9935 19.5478 14.2653 19.7269C14.0589 19.7777 13.7798 19.7777 13.2215 19.7777H6.11181C5.55349 19.7777 5.27434 19.7777 5.06795 19.7269C4.33973 19.5478 3.84928 18.9332 3.8914 18.2527C3.90333 18.0598 3.99161 17.8206 4.16816 17.3422C4.3151 16.9442 4.38857 16.7451 4.48924 16.5776C4.83768 15.9978 5.45963 15.5929 6.17886 15.4776C6.38667 15.4444 6.61893 15.4444 7.08364 15.4444ZM12.5556 9.66665C12.5556 11.2622 11.2622 12.5556 9.66665 12.5556C8.07112 12.5556 6.77771 11.2622 6.77771 9.66665C6.77771 8.07117 8.07112 6.77776 9.66665 6.77776C11.2622 6.77776 12.5556 8.07117 12.5556 9.66665Z",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveRolesIcon);
export default __webpack_public_path__ + "static/media/inactiveRolesIcon.076e9fc096ceeda493f2dc45adb65b05.svg";
export { ForwardRef as ReactComponent };